import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReferralRequestStatus, RespondentType } from './generated/referral-request';
import { useUpdateReferralRequest } from './hooks/use-update-referral-request';
import { ReferralRequestFormPage } from './referral-request-form-page';
import {
  toFormValues,
  type DraftReferralRequestLike,
  type ReferralRequestFormValues,
} from './referral-request-form-utils';

type ReferralRequestEditProps = {
  readonly id: string;
  readonly service: { description: string; respondentTypes: RespondentType[] };
  readonly draftReferralRequest: DraftReferralRequestLike;
};

const ReferralRequestEdit = ({ id, service, draftReferralRequest }: ReferralRequestEditProps) => {
  const navigate = useNavigate();
  const { result, updateReferralRequest } = useUpdateReferralRequest();

  const saveReferralRequest = async (values: ReferralRequestFormValues) => {
    await updateReferralRequest({ id, status: ReferralRequestStatus.Draft, ...values });
  };

  useEffect(() => {
    if (!result) return;
    navigate(result.surveyResponseId ? `/referral-request/${id}/survey` : '/');
  }, [result, id, navigate]);

  return (
    <ReferralRequestFormPage
      initialValues={toFormValues(draftReferralRequest, service.respondentTypes)}
      onSave={saveReferralRequest}
      service={service}
    />
  );
};

export { ReferralRequestEdit };
